import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface StoreState {
  externalObjectId: string | null;
  setExternalObjectId: (externalObjectId: string) => void;
  defaultInspectionComment: string | null;
  setDefaultInspectionComment: (defaultInspectionComment: string) => void;
  displayedMapLayers: string[];
  setDisplayedMapLayers: (displayedMapLayers: string[]) => void;
}

export const useStore = create<StoreState>((set) => ({
    externalObjectId: null,
    setExternalObjectId: (externalObjectId: string) => set({ externalObjectId }),
    defaultInspectionComment: null,
    setDefaultInspectionComment: (defaultInspectionComment: string) => set({ defaultInspectionComment }),
    displayedMapLayers:  JSON.parse(localStorage.getItem('displayedMapLayers') || '[]'),
    setDisplayedMapLayers: (displayedMapLayers: string[]) => {
      
      set({ displayedMapLayers })
      localStorage.setItem('displayedMapLayers', JSON.stringify(displayedMapLayers))
    },
}))